export enum ImageType
{
    ImageTypes='image/png,image/bmp,image/jpeg',
    PNG='image/png',
    JPG='image/jpeg',
    JPEG='image/jpeg',
    SVG='image/svg+xml',
    None='',
}